export default "__VITE_ASSET__DxQsx4Mu__"